// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { Observable, catchError, map, of } from 'rxjs';
import { BackendModelService } from './backend/backend-model.service';
import { KeyMap } from './climate-engine/ccc-algorithm/key-map';
import { ClimateCortexModel } from './climate-engine/ccc-algorithm/model-service/ccc.model.service';
import { ICarbonCausalChain } from './climate-engine/model/carbon-causal-chain';
import { ClimateCortexModel_v3 } from './climate-engine/model/climate-cortex-model';
import { IGlobalExternality } from './climate-engine/model/global-externality';
import { IResource } from './climate-engine/model/resource';
import { IStock } from './climate-engine/model/stock';
import { ITransitionElement } from './climate-engine/model/transition-element';
import { IVariable } from './climate-engine/model/variable';

@Injectable({
  providedIn: 'root',
})
export class ClimateCortexModelInitializerService {
  modelLoaded: boolean;
  model: ClimateCortexModel;
  constructor(private _backendModelService: BackendModelService) {
    this.modelLoaded = false;
  }

  loadCCModel(): Observable<boolean> {
    return this._backendModelService
      .getModel()
      .pipe(
        map((response) => {
          this.model = this._formatModel(response);
          this.modelLoaded = true;
          return true;
        })
      )
      .pipe(
        catchError((error) => {
          console.log(error);
          const empty: ClimateCortexModel = {
            transitionElements: {},
            carbonCausalChains: {},
            resources: {},
            variables: {},
            stocks: {},
            globalExternalities: {},
          };
          this.model = empty;
          this.modelLoaded = false;
          return of(false);
        })
      );
  }

  private _formatModel(decryptedCcModelV3: ClimateCortexModel_v3): ClimateCortexModel {
    const transitionElements: KeyMap<ITransitionElement> = {};
    decryptedCcModelV3.transitionElementDefinitions.forEach((t) => {
      transitionElements[t.transitionElement] = t;
    });
    const carbonCausalChains: KeyMap<ICarbonCausalChain> = {};
    decryptedCcModelV3.carbonCausalChainDefinitions.forEach((c) => {
      carbonCausalChains[c.ccc] = c;
    });
    const resources: KeyMap<IResource> = {};
    decryptedCcModelV3.resourceDefinitions.forEach((r) => {
      resources[r.resource] = r;
    });
    const stocks: KeyMap<IStock> = {};
    decryptedCcModelV3.stockDefinitions.forEach((s) => {
      stocks[s.stock] = s;
    });
    const globalExternalities: KeyMap<IGlobalExternality> = {};
    decryptedCcModelV3.globalExternalityDefinitions.forEach((ge) => {
      globalExternalities[ge.externality] = ge;
    });
    const variables: KeyMap<IVariable> = {};
    decryptedCcModelV3.variableDefinitions.forEach((v) => {
      variables[v.variable] = v;
    });

    return {
      transitionElements,
      carbonCausalChains,
      resources,
      stocks,
      globalExternalities,
      variables,
    };
  }
}
